import { TranRecordModel } from "./tran-record.model"

export class UpdateTranModel {
    Trans: TranRecordModel
    intIndex: number
    strStatus: string
    intStatus: boolean
    sglProcPrice: number
    BaseCharge: string
    Printable: number
    sglLinkUnit: number
    SaleTreat: string
    Chk: string    
    SalePrice: number
    UnitCost: number
    sglLUnit: number
    sglLinkCost: number

    constructor(
        Trans: TranRecordModel,
        intIndex: number,
        strStatus: string,
        intStatus: boolean,
        sglProcPrice: number,
        BaseCharge: string,
        Printable: number,
        sglLinkUnit: number,
        SaleTreat: string,
        sglLUnit: number
    ) {
        this.Trans = Trans
        this.intIndex = intIndex
        this.strStatus = strStatus
        this.intStatus = intStatus
        this.sglProcPrice = sglProcPrice
        this.BaseCharge = BaseCharge
        this.Printable = Printable
        this.sglLinkUnit = sglLinkUnit
        this.SaleTreat = SaleTreat
        this.sglLUnit = sglLUnit
    }
}